import React from "react";
import { Route, Routes, useLocation, Navigate } from "react-router-dom";
import Dashboard from '../Components/Dashboard/Dashboard';
import Login from "../Components/Auth/Login";
import PageNotFound from "../Components/404Error/PageNotFound";
import ActivityLogsPage from "../Pages/ActivityLogs";

const ProtectedRoute = () => {
    return <Navigate to="/" />;
};

const MainRouter = () => {
    // const newCheck = useSelector(state => state.utils.isCheck);
    const newCheck = JSON.parse(localStorage.getItem("login"))
    const pathName = useLocation().pathname;
    // useEffect(() => {
    //     console.log("Main Router component useEffect", newCheck);
    // })
    return (
        <Routes>
            {/* <Route path="/" element={<Login />} /> */}
            {newCheck ? (
                <Route exact path="/*" element={pathName === "/" ? <Navigate to={"/dashboard"} /> : <Dashboard />} />
            ) : (
                <>
                    <Route exact path={pathName.includes('/dashboard') ? "/dashboard" : "/"} element={pathName.includes('/dashboard') ? <ProtectedRoute /> : <Login />} />
                    <Route path="/*" element={<ProtectedRoute />} />
                   
                </>
            )}
             
            <Route path="*" element={<PageNotFound />} />
        </Routes>
    )
};

export default MainRouter;